import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeStatusCommand extends BaseCommand {
  CommandName = "ChangeStatus";
  Command: {
    Value: number;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, value: number) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Value: value };
  }
}
